import gql from 'graphql-tag';

import questionFields from 'src/graphql/fragments/questionFields';

export default gql`
  mutation deleteQuestionAudio(
    $questionId: ID
  ) {
    deleteQuestionAudio(
      questionId: $questionId
    ) {
      ...questionFields
    }
  }
  ${questionFields}
`;
